webpackJsonp([157614979532788],{

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hotels-and-lodging__hero.6f730050.jpg";

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hotels-lodging-1.f0fdbe17.jpg";

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hotels-lodging-2.50c22eed.jpg";

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hotels-lodging-3.84277016.jpg";

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(6);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _hotelsAndLodging__hero = __webpack_require__(511);
	
	var _hotelsAndLodging__hero2 = _interopRequireDefault(_hotelsAndLodging__hero);
	
	var _hotelsLodging = __webpack_require__(512);
	
	var _hotelsLodging2 = _interopRequireDefault(_hotelsLodging);
	
	var _hotelsLodging3 = __webpack_require__(513);
	
	var _hotelsLodging4 = _interopRequireDefault(_hotelsLodging3);
	
	var _hotelsLodging5 = __webpack_require__(514);
	
	var _hotelsLodging6 = _interopRequireDefault(_hotelsLodging5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Hotels & Lodging | What We Offer'
	      // meta={[{ name: 'description', content: '' }]}
	    }),
	    _react2.default.createElement(
	      _Header2.default,
	      { hero: _hotelsAndLodging__hero2.default },
	      _react2.default.createElement(
	        'h1',
	        { className: 't-hero' },
	        'Hotels & Lodging'
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { id: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-golden t-context--light' },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-golden__images c-golden__short min-laptop' },
	          _react2.default.createElement('img', { src: _hotelsLodging2.default, alt: '', style: { width: '50%', height: '100%' } }),
	          _react2.default.createElement('img', { src: _hotelsLodging4.default, alt: '', style: { width: '50%', height: '50%' } }),
	          _react2.default.createElement('img', { src: _hotelsLodging6.default, alt: '', style: { width: '50%', height: '50%' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-golden__content c-golden__wide' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'c-breadcrumbs mb30' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' },
	                'Home'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/what-we-offer' },
	                'What We Offer'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: '/what-we-offer/hotels-and-lodging',
	                  activeClassName: 'is-active'
	                },
	                'Hotels & Lodging'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-golden__text' },
	            _react2.default.createElement(
	              'div',
	              { className: 'c-golden__text-col' },
	              _react2.default.createElement(
	                'h1',
	                { className: 't-h1' },
	                'We\u2019re more than a Bedbank'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 't-p t-p-light mt30' },
	                'Offering preferred rates at over 25,000 properties, we are North America\u2019s leading accommodation and service provider. Our team of dedicated and experienced buyers negotiate unbeatable exclusive rates in not only North America\u2019s most popular destinations, but also in areas where availability is scarce, like our National Parks. ATI delivers more lodging availability inside America\u2019s National Parks than any other operator in the world. When your destination includes our majestic National Parks, only we can get you there. We also offer preferred rates at a broad array of specialty lodgings like short-term stay apartments, vacation rentals, house boats, ranches, luxury camping accommodations, and more\u2026 We\u2019re more than a Bedbank because we\u2019re dedicated to providing our clients with not just the lowest rates, but the support of a full-service tour operator.'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-what-we-offer-hotels-and-lodging-js-c511026e4a2feb65cd44.js